import { render, staticRenderFns } from "./AcceptRejectRequest.vue?vue&type=template&id=4395d804"
import script from "./AcceptRejectRequest.vue?vue&type=script&lang=js"
export * from "./AcceptRejectRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports